<app-title-section></app-title-section>

<!-- Menu interne supprimé : navigation uniquement via le menu gauche Vuexy. -->
<div
  class="email-application card ng-star-inserted parametre-content-only"
  style="margin-left: 15px; margin-right: 15px; background-color: transparent"
>
  <div class="content-area-wrapper parametre-content-full" style="gap: 0">
    <div class="content-right custom-scroll" style="overflow: auto; width: 100%; max-width: 100%;">
      <div class="content-wrapper p-0 conten-right-r">
        <div class="card">
          <div class="card-body" [class.param-content-loading]="paramNavLoading">
            <app-logiciel-caisse-parametre-progress></app-logiciel-caisse-parametre-progress>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
